import script from "./TableView.vue?vue&type=script&setup=true&lang=js"
export * from "./TableView.vue?vue&type=script&setup=true&lang=js"

import "./TableView.vue?vue&type=style&index=0&id=89d483ce&lang=scss&scoped=true"

import exportComponent from "E:\\online_project\\app_pcw365\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89d483ce"]])

export default __exports__